"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const row_module_scss_1 = __importDefault(require("./row.module.scss"));
const Row = ({ children, className, showBorderBottom, ...rest }) => {
    const classes = (0, classnames_1.default)({ [row_module_scss_1.default.borderBottom]: showBorderBottom }, className);
    return ((0, jsx_runtime_1.jsx)("tr", { className: classes, ...rest, children: children }));
};
exports.default = Row;
